import { forwardRef, PropsWithChildren } from "react"
import { ButtonProps } from "@mui/material"
import { SearchField, SearchFieldProps } from "../searchfield"
import { SearchFieldSelect, SearchFieldSelectEntryType } from "./SearchFieldSelect"
import { Loader } from "../../muiStyled/Feedback/loader"

type Props<T = unknown> = PropsWithChildren<SearchFieldProps> & {
    selectEntries?: SearchFieldSelectEntryType[]
    selectedEntry?: SearchFieldSelectEntryType
    selectEntriesLoading?: boolean
    onSelectedEntryChange: (entry: SearchFieldSelectEntryType) => void
    selectVariant?: ButtonProps["variant"]
}

export const SelectSearchField = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { children, selectedEntry, selectEntriesLoading, selectEntries, onSelectedEntryChange, selectVariant, wrapperBoxSx, sx, ...rest } = props

    return (
        <SearchField
            {...rest}
            ref={ref}
            autoComplete="off"
            sx={{
                width: "100%",
                maxWidth: "31vw",
                ...sx,
            }}
            wrapperBoxSx={{ width: "100%", ...wrapperBoxSx }}
            InputProps={{
                startAdornment: (
                    <>
                        {selectEntriesLoading && <Loader size="extrasmall" />}
                        {selectedEntry && (
                            <SearchFieldSelect
                                handleValueChange={onSelectedEntryChange}
                                value={selectedEntry}
                                entries={selectEntries}
                                buttonVariant={selectVariant}
                            />
                        )}
                    </>
                ),
            }}
        />
    )
})

export type { SearchFieldSelectEntryType }
